import script from "./FamilyPackEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyPackEditor.vue?vue&type=script&setup=true&lang=js"

import "./FamilyPackEditor.vue?vue&type=style&index=0&id=71f0e0bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f0e0bc"]])

export default __exports__